export function formatValue(value: string): string {
    return value.trim();
}
